<template>
    <div class="workinfo-share">
        <div class="footer" :class="{'zbgz-bg': hostname.includes('zhibugongzuo.com')}">
            <img src="@/assets/logo-zbgz.png" v-if="hostname.includes('zhibugongzuo.com')" alt="">
            <img src="@/assets/logo.png" v-else alt="">
            <a @click="agentNameZbgz()" v-if="hostname.includes('zhibugongzuo.com')" class="download">打开</a>
            <a @click="agentName()" v-else class="download">打开</a>
        </div>
        <swiper :options="swiperOption" v-if="swiperSlides.length&&!hasDelete">
            <swiper-slide v-for="(slide,index) in swiperSlides" :key="index">
                <div class="swiper-item" @click="imgBrower(index)"><img :src="slide.sets_url" alt=""></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="workinfo-block" v-if="!hasDelete" style="border-top:0;">
            <div class="workinfo-title">{{workInfoDetail.title}}</div>
            <div class="workinfo-time" >{{workInfoDetail.p_dept_name?workInfoDetail.p_dept_name + ' - ' : ''}}{{workInfoDetail.dept_name}}</div>
            <!-- <div class="workinfo-time" v-if="$route.query.template==3">{{moment(new Date(workInfoDetail.createdt*1000)).format('YYYY-MM-DD')}}发布</div>
            <div class="workinfo-time" v-else>{{workInfoDetail.createdt}}发布</div> -->
            <div class="video">
                <video :src="item.url" controls="controls" v-for="(item, index) in workInfoDetail.video" :key="index"></video>
            </div>
            <div class="workinfo-content" v-html="workInfoDetail.content_html" v-if="$route.query.template==3"></div>
            <div class="workinfo-content" v-html="workInfoDetail.content" v-else></div>
        </div>
        <div class="delete" v-if="hasDelete">
            <img src="@/assets/delete.png" v-if="isDelete" alt="">
            <img src="@/assets/cancel.png" v-else alt="">
            <span>{{message}}</span>
        </div>
        <!-- <div class="footer-block"></div> -->
    </div>
</template>

<script>
import qs from 'qs'
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import { ImagePreview } from 'vant';
import 'swiper/dist/css/swiper.css'
import moment from 'moment'
// import { videoPlayer } from 'vue-video-player'
export default {
    name: 'workinfo-share',
    data () {
        return {
            message: '内容已被删除',
            hasDelete: false,
            isDelete: true,
            swiperSlides: [],
            moment: moment,
            swiperIndex: 0,
            swiperOption: {
                loop: {
                    loop: true
                },
                pagination: {
                    el: '.swiper-pagination',
                    type: 'fraction'
                },
                autoHeight: true // enable auto height
            },
            workInfoDetail: {},
            content: '',
            hostname: '',
            isPlay: false,
            progress: 0,
            shareParams: {
                appId: '',
                nonceStr: '',
                signature: '',
                timestamp: '',
                url: ''
            }
        }
    },
    components: {
        // videoPlayer,
        swiper,
        swiperSlide
    },
    computed: {
    },
    created() {
        this.hostname = location.hostname
    },
    mounted () {
        if (this.$route.query.template * 1 === 1) {
            this.loadData('/work/shareactivity/getBranchDetailNew')
        }
        if (this.$route.query.template * 1 === 2) {
            this.loadData('/work/shareactivity/getCommitteeDetailNew')
        }
        if (this.$route.query.template * 1 === 3) {
            this.loadData('/work/shareactivity/detail')
        }
    },
    methods: {
        agentName() {
            var u = navigator.userAgent;
            // var app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            if (isAndroid) {
                window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tfkj.partybuildingcloud';
            }
            if (isIOS) {
                window.location.href = 'https://itunes.apple.com/cn/app/id1129716344?l=zh&ls=1&mt=8';
            }
        },
        agentNameZbgz() {
            var u = navigator.userAgent;
            // var app = navigator.appVersion;
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; // g
            var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); // ios终端
            if (isAndroid) {
                window.location.href = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.tfkj.activitiesofthebranch';
            }
            if (isIOS) {
                window.location.href = 'https://itunes.apple.com/cn/app/id921985296?mt=8';
            }
        },
        play(flag) {
            if (flag) {
                this.$refs.video.play()
            } else {
                this.$refs.video.pause()
            }
        },
        imgBrower(index) {
            ImagePreview({
                images: this.swiperSlides.map(val => {
                    return val.sets_url
                }),
                startPosition: index,
                onClose() {
                    // do something
                }
            });
        },
        loadData(url) {
            this.axios.post(url, qs.stringify({act_id: this.$route.query.act_id}))
                .then(res => {
                    if (res.data.code === 200) {
                        document.title = res.data.data.title;
                        this.workInfoDetail = res.data.data;
                        this.content = this.workInfoDetail.content.split(/\r?\n/).join(' ')
                        this.workInfoDetail.content = this.workInfoDetail.content.split(/\r?\n/)
                        let str = ''
                        this.workInfoDetail.content.forEach(element => {
                            str += '<p>' + element + '</p>'
                        });
                        this.workInfoDetail.content = str
                        this.swiperSlides = res.data.data.img ? res.data.data.img : []
                        // document.title = this.data.v_introduce
                        let isWechat = navigator.userAgent.indexOf('MicroMessenger') > -1
                        if (isWechat) {
                            // 微信内部
                            this.loadParams()
                        }
                    } else if (res.data.code * 1 === 5001) {
                        this.message = '内容已被删除'
                        this.isDelete = true
                        this.hasDelete = true
                    } else if (res.data.code * 1 === 5002) {
                        let title = '党建云'
                        if (this.hostname.includes('zhibugongzuo.com')) {
                            title = '支部工作'
                        }
                        this.message = '内容已禁止分享，请登录' + title + '查看'
                        this.isDelete = false
                        this.hasDelete = true
                    } else {
                        this.$toast.fail({
                            duration: 3000,
                            message: res.data.msg
                        })
                    }
                }).catch(err => {
                    console.log(err)
                    this.$toast.fail({
                        duration: 3000,
                        message: '网络返回失败'
                    })
                })
        },
        loadParams() {
            // let protocol = window.location.protocol
            // let host = window.location.host
            this.axios.post('/ucenter/index/wechatshare', qs.stringify({url: location.href}))
                .then(res => {
                    if (res.data.code === 200) {
                        this.shareParams = res.data.data
                        this.$nextTick(() => {
                            this.share(res.data.data)
                        })
                    } else {
                        console.log(res.data.msg)
                    }
                }).catch(err => {
                    console.log(err)
                    this.$toast.fail({
                        duration: 3000,
                        message: '网络返回失败'
                    })
                })
        },
        share (data) {
            // let title = '党建云'
            // if (this.hostname.includes('zhibugongzuo.com')) {
            //     title = '支部工作'
            // }
            window.wx.config({
                debug: false, // 是否开启调试模式
                appId: data.appId, // appid
                timestamp: data.timestamp, // 时间戳
                nonceStr: data.nonceStr, // 随机字符串
                signature: data.signature, // 签名
                jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData']
            })
            window.wx.ready(() => {
                let link = data.url
                let title = this.workInfoDetail.title
                let content = this.content
                // let imgUrl = this.workInfoDetail.share_cover
                let imgUrl = location.protocol + '//' + location.host + '/mobile/wxworkinfoshare/static/share_logo.jpg'
                window.wx.checkJsApi({
                    jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'],
                    success: (res) => {}
                })
                window.wx.updateTimelineShareData({
                    title: title, // Share title
                    link: link, // Share link, this link domain name and path must be the same as the current page which corresponding to JS secured domain name as Official account
                    imgUrl: imgUrl, // protocol + '//' + host + '/h5national70/static/img/70zhounian.jpg', // Share icons.
                    success: () => { },
                    cancel: () => { }
                })
                window.wx.updateAppMessageShareData({
                    title: title, // Share title
                    link: link, // Share Link,this link domain name and path must be the same as the current page which corresponding to JS secured domain name as Official account
                    desc: content,
                    imgUrl: imgUrl, // Share Icon
                    type: 'link', // Share type, music, video link, not filled default link
                    success: () => { },
                    cancel: () => { }
                })
            })
        }
    }

}
</script>

<style lang="less" scoped>
.swiper-item{
    display: block;
    img{
        display: block;
        width: 100%;
    }
}
.swiper-pagination{
    text-align: right;
    color: #fff;
    padding-right: 32px;
    padding-bottom: 20px;
    padding-top: 20px;
    font-size: 34px;
    bottom: 0;
    background-image: linear-gradient(transparent,rgba(0,0,0,.8));
}
.workinfo-share{
    width: 100vw;
    height: 100vh;
    overflow: auto;
    position: relative;
    background: #f7f7f7;
    z-index: 3;
    .delete{
        height: calc(100% - 1.56rem);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        img{
            width: 164px;
            height: 143px;
            display: block;
        }
        span{
            color: #333333;
            font-size: 34px;
            margin-top: 25px;
        }
    }
    .workinfo-block{
        padding: 30px;
        border-top: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        // margin-bottom:30px;
        background: #ffffff;
        .workinfo-title{
            font-size: 42px;
            letter-spacing: 3px;
            color: #111111;
            font-weight: bold;
        }
        .workinfo-time{
            font-size: 26px;
            letter-spacing: 1px;
            color: #999999;
            padding: 25px 0;
        }
        .workinfo-content{
            font-size: 34px;
            letter-spacing: 2px;
            color: #111111;
            text-align: justify;
            word-break: break-all;
            line-height: 175%;
            /deep/ img{
                max-width: 100%;
                display: block;
                margin: 0 auto;
            }
            /deep/ p{
                text-indent: 2em;
                margin-bottom: 40px;
            }
        }
        .video{
            width: 100%;
            margin-bottom: 20px;
            video{
                width: 100%;
                height: 400px;
            }
        }
        .workinfo-video{
            padding: 20px 0;
            .video-item{
                display: flex;
                flex-direction: row;
                align-items: center;
                color: #0e83d8;
                font-size: 30px;
                height: 50px;
                img{
                    width: 43px;
                    height: 30px;
                    display: block;
                }
                span{
                    padding-left: 24px;
                }
            }
        }
        .workinfo-taglist{
            .tag-item{
                height: 60px;
                display: inline-flex;
                padding: 0 30px;
                border-radius: 30px;
                background-color: #fcfcfc;
                border: solid 2px #dddddd;
                margin-right: 20px;
                align-items: center;
                color: #333333;
                font-size: 30px;
                margin-bottom:20px;
            }
        }
        .title{
            color: #111111;
            font-size: 34px;
            font-weight: bold;
            padding-bottom: 10px;
        }
        .about-info-item{
            display: flex;
            flex-direction: row;
            align-items: flex-start;
            margin-top: 25px;
            .img{
                display: flex;
                align-items: center;
                justify-content: center;
                max-width: 23px;
                max-height: 23px;
                margin-top: 10px;
                margin-right: 15px;
                img{
                    display: block;
                    max-width: 23px;
                    max-height: 23px;
                }
            }
            .about-title{
                width: 165px;
                font-size: 30px;
                color: #111111;
                .size2{
                    letter-spacing: 30px;
                }
                .size3{
                    letter-spacing: 9.6px;
                }
                .size4{
                    letter-spacing: 0px;
                }
            }
            .about-content{
                color: #999999;
                font-size: 30px;
                width: 100px;
                flex: 1;
            }
        }
        .workinfo-affix{
            padding-top: 40px;
            .affix-item{
                width: 100%;
                height: 120px;
                background-color: #fafafa;
                border: solid 1px #eeeeee;
                display: flex;
                flex-direction: row;
                align-items: center;
                .affix-left{
                    flex: 1;
                    width: 100px;
                    padding-left: 23px;
                    .name{
                        color: #111111;
                        font-size: 30px;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        word-wrap: normal;
                        overflow: hidden;
                    }
                    .size{
                        color: #999999;
                        font-size: 26px;
                    }
                }
                .download{
                    width: 112px;
                    height: 48px;
                    background-color: #ffffff;
                    border: solid 2px #dddddd;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #e71e1e;
                    font-size: 26px;
                    border-radius: 24px;
                    margin:0 20px;
                }
            }
        }
    }
    .workinfo-block2{
        padding: 30px;
        border-top: 1px solid #dddddd;
        border-bottom: 1px solid #dddddd;
        margin-bottom:30px;
        background: #ffffff;
        .deptName{
            font-size: 34px;
            color: #111111;
        }
        .deptName2{
            font-size: 26px;
            margin-top: 10px;
            color: #999999;
        }
        .focus{
            border-radius: 4px;
            background-color: #e71e1e;
            width: 150px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #ffffff;
            font-size: 30px;
        }
    }
    // .footer-block{
    //     padding-top: 117px;
    // }
    .footer{
        width: 100%;
        height: 117px;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 0 25px;
        // position: fixed;
        // bottom: 0;
        // left: 0;
        z-index: 9;
        img{
            display:inline-block;
            height: 70px;
        }
        .download{
            height: 48px;
            padding: 0 20px;
            background-color: #e71e1e;
            border-radius: 4px;
            line-height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 30px;
            color: #fff;
            border-radius: 8px;
            font-size: 26px;
        }
    }
    .footer.zbgz-bg {
        background-color: #fff;
    }
}
</style>



// WEBPACK FOOTER //
// src/views/workinfo-share.vue